import { render, staticRenderFns } from "./GFSettlementForm.vue?vue&type=template&id=74a5ec84&scoped=true"
import script from "./GFSettlementForm.vue?vue&type=script&lang=js"
export * from "./GFSettlementForm.vue?vue&type=script&lang=js"
import style0 from "./GFSettlementForm.vue?vue&type=style&index=0&id=74a5ec84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5ec84",
  null
  
)

export default component.exports